import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { ConsorsNotesTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    noteId: string;
    position?: number;
    subscriptionIdentifier: string;
};

export const schemaLoanRequestResolver_GetConsorsNoteStatus =
    ConsorsNotesTableDefinitionZod.shape.notes.element.optional();

export type SchemaLoanRequestResolver_GetConsorsNoteStatus = z.infer<
    typeof schemaLoanRequestResolver_GetConsorsNoteStatus
>;

export type LoanRequestResolver_GetConsorsNoteStatus = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetConsorsNoteStatus
>;
